import React from 'react'

const Error404 = () => {
  return (
    <>
        <h1>Error 404</h1>
        <a href='/'>Go Back 👈</a>
    </>
  )
}

export default Error404